module.exports = __webpack_public_path__ + "img/tab-profile-inactive.ff613c0.png";